export default __webpack_public_path__ + "static/html-6e930594286d8afe4c7934f5baf221ca.png";